import { Avatar } from 'antd';
import React, { useContext } from 'react';
import { Context } from '../MunicipalNoticeBoard';
import { IFolderData } from '../utils/interface';

export const CatAvatar: React.FC<{ folder: IFolderData }> = ({ folder }) => {
    const { icons } = useContext(Context);

    const iconUrl = folder.iconId && icons?.get(folder.iconId as string)?.url;

    if (iconUrl) {
        return <Avatar src={iconUrl} alt={'Icon für ' + folder.name} />;
    }

    return <></>;
};
